import React, { useState, useEffect } from "react";

const ReferralModal = ({ isOpen, onClose, referral, setIsOpen, onCreate, onUpdate }) => {
  const [referralName, setReferralName] = React.useState(referral ? referral.name : "");

  const handleCreate = async (event) => {
    event.preventDefault();
    try {
      await onCreate({ name: referralName });
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const [error, setError] = useState(null);

  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      await onUpdate({ name: referralName });
      setIsOpen(false);
    } catch (error) {
      setError(error.message);
      console.error(error);
    }
  };
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex items-center justify-center ${
        isOpen ? "block" : "hidden"
      }`}
    >
      <div className="bg-white rounded-lg shadow-md p-6 w-1/2">
        <h2 className="text-2xl font-bold mb-4">
          {referral ? "Edit Referral" : "Create Referral"}
        </h2>
        <form onSubmit={referral ? handleUpdate : handleCreate}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
              Name
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="referralName"
              type="text"
              value={referralName}
              onChange={(event) => {setReferralName(event.target.value) }}
            />
          </div>
          <button
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            type="submit"
          >
            {referral ? "Update" : "Create"}
          </button>
          <button
            className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
            type="button"
            onClick={onClose}
          >
            Cancel
          </button>
        </form>
        {error && <div className="text-red-500 mt-4">{error}</div>}
      </div>
    </div>
  );
};

export default ReferralModal;
